/*@ngInject*/
const UserGroupsBrowserRepository = function (baseRepository, coreMediator) {

    angular.extend(this, baseRepository);

    this.loadUserGroupsActions = function () {
        let url = '/rest/Actions',
            config = {
                params: {
                    uri: 'com.firstbest.user.UserGroup:null'
                }
            };
        return this.get(url, config);
    };

    this.getUserGroups = function (nameSearchString, params) {
        let url = '/rest/UserGroup/List',
            config = {
                params: {
                    name: nameSearchString,
                    startIndex: params.startIndex,
                    numberOfRows: params.pageSize,
                    sortBy: params.key,
                    sortDirection: params.sortType
                }
            };

        return this.get(url, config);
    };

};

angular.module('umCore')
    .service('userGroupsBrowserRepository', UserGroupsBrowserRepository);
